import _ from 'lodash';
import { Component, Input, Output, EventEmitter } from '@angular/core';
import { FileSystemDirectoryEntry, FileSystemFileEntry, NgxFileDropEntry, NgxFileDropModule } from 'ngx-file-drop';
import { CommonModule } from '@angular/common';

@Component({
  standalone:true,
  imports:[CommonModule, NgxFileDropModule],
  selector: 'app-file-drop',
  templateUrl: './file-drop.component.html',
  styleUrls: ['./file-drop.component.scss']
})
export class FileDropComponent {

  public files: NgxFileDropEntry[] = [];

  @Input()
  public extensions: string[] = [];

  @Input()
  public types: string[] = [];

  @Output()
  public onSelect: EventEmitter<any> = new EventEmitter();

  public dropped(files: NgxFileDropEntry[]) {
    this.files = files;
    for (const droppedFile of files) {

      // Is it a file?
      if (droppedFile.fileEntry.isFile) {
        const fileEntry = droppedFile.fileEntry as FileSystemFileEntry;
        fileEntry.file((file: File) => {

          const fileNameArray = _.split(file.name, '.');
          const fileExtension = _.last(fileNameArray);
          if(this.extensions.length > 0) {
            const found = _.find(this.extensions, (extension) => _.isEqual(extension, fileExtension)) || false;
            if(found === false) return;
          }


          if(this.types.length > 0) {
            const found = _.find(this.types, (type) => {
              const regexp = new RegExp(type, 'g');
              return regexp.exec(file.type);
            }) || false;
            if(found === false) return;
          }

          this.onSelect.next(file);

        });
      } else {
        // It was a directory (empty directories are added, otherwise only files)
        const fileEntry = droppedFile.fileEntry as FileSystemDirectoryEntry;
      }
    }
  }

  public fileOver(event){
  }

  public fileLeave(event){
  }
}
